export default "__VITE_ASSET__DxHGwxi6__"